module.exports = __webpack_public_path__ + "img/sienna.c911536c.png";